import { render } from "./TableCard.vue?vue&type=template&id=1118cdd8&scoped=true"
import script from "./TableCard.vue?vue&type=script&lang=js"
export * from "./TableCard.vue?vue&type=script&lang=js"

import "./TableCard.vue?vue&type=style&index=0&id=1118cdd8&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1118cdd8"]])

export default __exports__